import { Item } from "types";

const bankActionRequiredStatus = [402, 429, 430, 1003, 1010, 1100];

const checkIfBankActionRequired = (items: Item[]) => {
  return items.some((item) => bankActionRequiredStatus.includes(item.status));
};

export default checkIfBankActionRequired;
